export default __webpack_public_path__ + "static/media/onsite-images.593a305f.svg";